import { PaymentMethodsType as PaymentMethods } from "@/types/organizations";

export const paymentMethodsLabels = {
  [PaymentMethods.CASH]: "Efectivo",
  [PaymentMethods.CREDIT_CARD]: "Tarjeta Crédito/Débito",
  [PaymentMethods.BANK_TRANSFER]: "Transferencia a banco",
};

export const bankOptions = [
  { label: "Bac", value: "bac" },
  { label: "Banpro", value: "banpro" },
  { label: "Ficohsa", value: "ficohsa" },
  { label: "Lafise", value: "lafise" },
  { label: "Avanz", value: "avanz" },
];

export const currencyOptions = [
  { label: "Dólares", value: "USD" },
  { label: "Córdobas", value: "NIO" },
];

export const creditCardOptions = [
  { label: "Visa", value: "visa" },
  { label: "American Express", value: "american-express" },
  { label: "Mastercard", value: "mastercard" },
  { label: "Discover", value: "discover" },
  { label: "Dinners Club", value: "dinners-club" },
];

export const cashOptions = [
  {label: "100", value: 100},
  {label: "200", value: 200},
  {label: "500", value: 500},
  {label: "1000", value: 1000},
]